import { render, staticRenderFns } from "./WizardContentTextEditor.vue?vue&type=template&id=08956c7c&scoped=true&"
import script from "./WizardContentTextEditor.vue?vue&type=script&lang=ts&"
export * from "./WizardContentTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentTextEditor.vue?vue&type=style&index=0&id=08956c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08956c7c",
  null
  
)

export default component.exports